export default {
  es: {
    SORT_BY: 'Ordenar por',
    SELECT_DOWNLOADABLE: 'Seleccionar descargable',
    NO_RESULTS_FOUND: 'Oops, no se encontraron resultados',
    ALL_DOWNLOADABLE: 'Todos los descargables',

    HERO_TITLE: 'Descargables',
    HERO_DESCRIPTION:
      'Consulta los mejores recursos de tu interés para estar en tendencia',

    SEO_TITLE: 'Descargables | Crehana para empresas',
    SEO_DESCRIPTION:
      'Diseñamos entrenamiento ágil con profesionales de Google, Facebook, Amazon y más. Mejora las habilidades de tu equipo en diseño, data, transformación digital, softskills y más.',

    ORDER_ALL: 'Todos',
    ORDER_RECENT: 'Lo más reciente',
    ORDER_POPULARITY: 'Lo más popular',
    ORDER_OLDER: 'Lo más antiguo',
  },
};
